export const GET_SYSTEM_SETTING = "get_system_setting";
export const EDIT_SYSTEM_SETTING = "edit_system_setting";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const ERROR = "error";
export const ACCESS_RIGHT_ERROR = "access_right_error";
export const DATA_DECLERATION_PDF = "DATA_DECLERATION_PDF";
